import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_LegalPerson_PageMenu_ApiEnum } from './LegalPersonDetailConfigApiInterface';
import { Config_Person_PageMenu_ApiEnum } from './PersonDetailConfigApiInterface';

export enum Config_AgentsContractsSearch_ActionsMenu_ApiEnum {
    'create_agent_contract' = 'create_agent_contract',
}

export enum Config_AgentsContractsSearch_Modules_ApiEnum {
    'results' = 'results',
    'overview' = 'overview',
    'indications' = 'indications',
}

export enum Config_AgentsContractsSearch_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_AgentsContractsSearch_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_AgentsContractsSearch_ApiInterface
    extends ConfigDataInterface<
        Config_AgentsContractsSearch_Modules_ApiEnum,
        Config_AgentsContractsSearch_ActionsMenu_ApiEnum,
        Config_AgentsContractsSearch_ActionsOther_ApiEnum,
        Config_LegalPerson_PageMenu_ApiEnum | Config_Person_PageMenu_ApiEnum,
        Config_AgentsContractsSearch_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
